module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/LezioneDodiciDuePDF.44bc7667.png";